import React,{ useState, useEffect } from 'react';
import { 
    notification, 
    DatePicker, 
    Col, 
    Flex, 
    Button, 
    Spin, 
    Row } from 'antd';
import Slider from "react-slick";
import axios from 'axios';
import InternetProductCard from './InternetProductCard';
import QualificationForm from '../tools/QualificationForm';
import NoServices from './NoServices';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const siteDomain = headerVars.siteDomain;

function InternetServices( { isCartComponent, isHomeComponent, isFibreComponent } ) {
    let [productList, setproductList] = useState([]);
    let [cartUpdateState, setcartUpdateState] = useState('');
    let [spinnerDisplay, setSpinnerDisplayState] = useState('');
    let [cardLoadingDisplay, setCardLoadingDisplayState] = useState(false);
    let [noSevicesAvailable, setNoSevicesAvailable] = useState( <></> );
    let [cardVisibility, setCardVisibility] = useState( ( isFibreComponent ) ? false:true);
    let [d2cDataParsed, setD2cDataParsed] = useState(false);
    let [hasFibreServices, setHasFibreServices] = useState( false );
    const [koodoRedirectLoading, setKoodoRedirectLoading] = useState( false );
    let products = [];
    let addingToCart = false;
    let sliderSettings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3.2,
        slidesToScroll: 3,
        initialSlide: 0,
        responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 2,
              initialSlide: 0
            }
          },{
            breakpoint: 900,
            settings: {
              slidesToShow: 2.2,
              slidesToScroll: 2,
              initialSlide: 0
            }
          },{
            breakpoint: 768,
            settings: {
              slidesToShow: 1.8,
              slidesToScroll: 1,
              initialSlide: 0
            }
          },{
            breakpoint: 600,
            settings: {
              slidesToShow: 1.3,
              slidesToScroll: 1,
              initialSlide: 0
            }
          },{
            breakpoint: 475,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0
            }
          },{
            breakpoint: 410,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0
            }
          },
        ]
    };

    const [api, contextHolder] = notification.useNotification();

    let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};

    useEffect(() => {
        const url_string = window.location.href;
        let url = new URL(url_string);
        const cartItems = url.searchParams.get("cart-items");
        const displayCart = url.searchParams.get("show-cart");

        //console.log('displayCart:: ', displayCart);

        buildProductList( [], '', false );
        let form_data = new FormData;
        form_data.append('action', 'startca_get_products');
        let availableServices = '';
        availableServices = jQuery('#qualificationData').val();

        if( availableServices == '' || availableServices == null ) {
            availableServices = document.cookie.match('(^|;)\\s*' + 'qualification-data' + '\\s*=\\s*([^;]+)')?.pop() || '';
        }

        availableServices = decodeURIComponent( availableServices );
        availableServices = availableServices.replace(/\\/g, '');
        form_data.append('qualified_services', availableServices );

        const updateInternetUpdateState = ({ detail }) => {
            buildProductList( [], '', false );

            //let availableServicesObj = JSON.parse( availableServices );
            availableServices = document.cookie.match('(^|;)\\s*' + 'qualification-data' + '\\s*=\\s*([^;]+)')?.pop() || '';
            form_data.append('qualified_services', availableServices );

            //console.log('availableServices:: ', availableServices);

            axios
            .post(requestUrl.ajax_url, form_data)
            .then(function(response){
                products = response.data;

                if( products.length ) {
                    if( isFibreComponent) {
                        if( products[0].vendor == 'Fibre' ) {
                            setCardVisibility( true );
                            setNoSevicesAvailable(<></>);
                            buildProductList( products, '', false );
                            setHasFibreServices(true);
                        } else {
                            setCardVisibility( false );
                            setNoSevicesAvailable(
                                <NoServices isFibreComponent={ true }/>
                            );
                        }
                    } else {
                        if( products[0].qualified == false ) {
                            setCardVisibility( false );
                            setNoSevicesAvailable(<></>);
                            //buildProductList( [], '', false );
                        } else {
                            setCardVisibility( true );
                            setNoSevicesAvailable(<></>);
                            buildProductList( products, '', false );
                        }
                    }
                } else {
                    setCardVisibility(false);
                    setNoSevicesAvailable(
                        <NoServices />
                    );
                    //buildProductList( products, '', false );
                }
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function () {
                // always executed 
            }); 
        }

        document.addEventListener(`cartInternetProductsUpdateState`, updateInternetUpdateState);

        if( displayCart ) {
            var overlayCanvas = jQuery("#cart-drawer").find('.off-canvas');
            var overlay = jQuery("#cart-drawer").find(".is-overlay-fixed");
            overlayCanvas.toggleClass("is-open");
            overlay.toggleClass("is-visible");
            overlay.toggleClass("is-closable");
            jQuery("#tv-channel-drawer-closer").focus();
            document.dispatchEvent(new CustomEvent('cartUpdateState', { detail: '' }));
        } else if( cartItems && !d2cDataParsed ) {
            let d2c_form_data = new FormData;
            d2c_form_data.append('action', 'startca_parse_d2c_data');

            //https://startwpdev.wpengine.com/services/high-speed-internet?cart-items=1373,1519,5044&customer-first-name=Jason&customer-last-name=Pembleton&customer-email=jason.pembleton@team.start.ca&customer-phone=(416)%20878-7003&existing-account-number=123456&ship-to-service-address=&bill-to-service-address=&existing-startca-account-holder=&cancellation-date=&cancellation-status=&cancel-for-me-date=&existing-startca-account-number=&install_type=cable-provider-cancel&address-unit-number=&own-modem-type=&own-modem-serial=&own-modem-mac=&self-install=ENABLED&use-own-modem=&install-date=2024-05-15&install-time=&service-address=753%20Garibaldi%20Ave,%20London,%20Ontario,%20N5X%204J8&order=8023&shipping-fee=10&install-fee=0&available-services=5286487a271d803a0c1dfbfd696b2cef,c0362445b36886ac7dfac3b82142e272,aa8bd2860026235a7951b9eeec401f31,8ec394cc680308278fac79330ba65deb&self-install=ENABLED&provider=Rogers&install-timestamp=1715731200&leadtime=&shipping-address=753%20Garibaldi%20Ave,%20London,%20Ontario,%20N5X%204J8&billing-address=753%20Garibaldi%20Ave,%20London,%20Ontario,%20N5X%204J8&kudos-promo=&coupon=&current-provider=execulink&includes-fibre-upgrade-agreement=true

            const customerFirstName = url.searchParams.get("customer-first-name");
            const customerLastName = url.searchParams.get("customer-last-name");
            const customerEmail = url.searchParams.get("customer-email");
            const customerPhone = url.searchParams.get("customer-phone");
            const existingAccountNumber = url.searchParams.get("existing-account-number");
            const existingStartAccountHolder = url.searchParams.get("existing-startca-account-holder");
            const serviceAddress = url.searchParams.get("service-address");
            const shippingAddress = url.searchParams.get("shipping-address");
            const billingAddress = url.searchParams.get("billing-address");
            const cancellationDate = url.searchParams.get("cancellation-date");
            const cancellationStatus= url.searchParams.get("cancellation-status");
            const cancelForMeDate= url.searchParams.get("cancellation-date");
            const installType= url.searchParams.get("install_type");
            const addressUnitNumber= url.searchParams.get("address-unit-number");
            const selfInstall= url.searchParams.get("self-install");
            const installDate= url.searchParams.get("install-date");
            const installTime= url.searchParams.get("install-time");
            const orderNumber= url.searchParams.get("order");
            const shippingFee= url.searchParams.get("shipping-fee");
            const installFee= url.searchParams.get("install-fee");
            const availableServices= url.searchParams.get("available-services");
            const provider= url.searchParams.get("provider");
            const installTimestamp= url.searchParams.get("install-timestamp");
            const leadTime= url.searchParams.get("leadtime");
            const coupon= url.searchParams.get("coupon");
            const currentProvider= url.searchParams.get("current-provider");
            const includesFibreUpgradeAgreement= url.searchParams.get("includes-fibre-upgrade-agreement");

            console.log('provider:::::::: ', provider);

            d2c_form_data.append('cart_items', cartItems);
            d2c_form_data.append('customer-first-name', customerFirstName);
            d2c_form_data.append('customer-last-name', customerLastName);
            d2c_form_data.append('customer-email', customerEmail);
            d2c_form_data.append('customer-phone', customerPhone);
            d2c_form_data.append('existing-account-number', existingAccountNumber);
            d2c_form_data.append('existing-startca-account-holder', existingStartAccountHolder);
            d2c_form_data.append('service-address', serviceAddress);
            d2c_form_data.append('shipping-address', shippingAddress);
            d2c_form_data.append('billing-address', billingAddress);
            d2c_form_data.append('cancellation-date', cancellationDate);
            d2c_form_data.append('cancellation-status', cancellationStatus);
            d2c_form_data.append('install_type', installType);
            d2c_form_data.append('address-unit-number', addressUnitNumber);
            d2c_form_data.append('self-install', selfInstall);
            d2c_form_data.append('install-date', installDate);
            d2c_form_data.append('install-time', installTime);
            d2c_form_data.append('order', orderNumber);
            d2c_form_data.append('shipping-fee', shippingFee);
            d2c_form_data.append('install-fee', installFee);
            d2c_form_data.append('available-services', availableServices);
            d2c_form_data.append('provider', provider);
            d2c_form_data.append('install-timestamp', installTimestamp);
            d2c_form_data.append('leadtime', leadTime);
            d2c_form_data.append('coupon', coupon);
            d2c_form_data.append('current-provider', currentProvider);
            d2c_form_data.append('includes-fibre-upgrade-agreement', includesFibreUpgradeAgreement);

            console.log('got cart items!!!');
            openNotification('top', 'Building your order', 'You will be redirected to the cart in a jiffy.');

            axios
            .post(requestUrl.ajax_url, d2c_form_data)
            .then(function(response){
                let d = response.data;
                console.log('d: ', d);
                setD2cDataParsed( true );
                window.location.search += '&show-cart=true';
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function () {
                // always executed 
            }); 
        } else {
            axios
            .post(requestUrl.ajax_url, form_data)
            .then(function(response){
                products = response.data;
                //console.log('products:: ', products);
                if( products.length ) {
                    if( products[0].vendor == "Rogers" ) {
                        setCardVisibility(false);
                    } else {
                        buildProductList( products, '', false );
                    }
                } else {
                    setCardVisibility(false);
                }
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function () {
                // always executed 
            }); 
        }

        return () => document.removeEventListener(`cartInternetProductsUpdateState`, updateInternetUpdateState)

    }, [cardVisibility]);

    const openNotification = ( placement, productName, description ) => {
        api.info({
            message: productName,
            description: description,
            placement,
        });
    }

    const buildProductList = ( products, productId, addingToCart ) => {
        let productList = [];
        let productCard = '';

        if( cardVisibility ) {
            if(products.length <= 0 ) {
                for( var i=0; i < 4; i++ ) {
                    productCard = 
                    <InternetProductCard 
                        handleAddToCart={ handleAddToCart } 
                        productData={ [] }
                        activeProductId={ 0 }
                        addingToCart={ false }
                        isLoading={ true }
                        isPlaceholder={true}
                    />
                    productList.push(productCard);
                }

            } else {
                for( var i=0; i < products.length; i++ ) {
                    productCard = 
                    <InternetProductCard 
                        handleAddToCart={ handleAddToCart } 
                        productData={ products[i] }
                        activeProductId={ productId }
                        addingToCart={ addingToCart }
                        isLoading={ cardLoadingDisplay }
                        isPlaceholder={ false }
                        isCartComponent={ isCartComponent }
                    />
    
                    productList.push(productCard);
                }
            }
        }
        setproductList( productList );
    }

    const onChange = (date, dateString) => {
        console.log(date, dateString);
    };

    const updateCartIcon = ( cartServiceQuantity ) => {
        jQuery( '.header-cart-icon' ).html('<span class="cart-contents-quantity">'+cartServiceQuantity+'</span>');
    }
    
    const handleAddToCart = ( productId, productName ) => {
        let form_data = new FormData;
        form_data.append('action', 'startca_add_to_cart');
        form_data.append( 'id', productId );
    
        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};

        addingToCart = true;
        buildProductList(products, productId, addingToCart);
        //console.log("productList: ", productList);
    
        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function(response){
            //console.log(response.data);
            let serviceCount = response.data['service_count'];
            //console.log(serviceCount);
            //cartUpdateState = response.data;
            //document.dispatchEvent(new CustomEvent('cartUpdateState', { detail: cartUpdateState }));

            addingToCart = false;
            buildProductList(products, productId, addingToCart);

            openNotification('topLeft', productName, 'Has been added to your cart.');
            updateCartIcon( serviceCount );

        })
        .catch(function (error) {
            console.log(error);
            addingToCart = false;
        })
        .finally(function () {
            // always executed
        }); 
    }; 

    const checkForAddQualificationForm = () => {
        if( isHomeComponent ) {
            return( <QualificationForm koodoRedirectLoading={ koodoRedirectLoading }
                setKoodoRedirectLoading={ setKoodoRedirectLoading }/> )
        }else if( isFibreComponent ) {
            return( <QualificationForm isFibreComponent={ true } hasFibreServices={ hasFibreServices }/> );
        } else {
            return( <></> );
        }
    }

    return (
        <div className="react-service-details-internet">
            { checkForAddQualificationForm() }

            <Flex horizontal justify='center'>
                <div className={`spinner ${spinnerDisplay}`}>
                    <Spin size="large"/>
                </div>
            </Flex>

            <Slider 
                { ...sliderSettings }
                ref={slider => {
                    slider?.slickGoTo(0)
                }}
            >
                { productList }
            </Slider>
            { contextHolder }
            { noSevicesAvailable }
        </div>
    )
}

export default InternetServices